export const DocTypeTypes = {
  PROJECT_DOC: "PROJECT_DOC", // Проектная документация
  WORK_DOC: "WORK_DOC", // Рабочая документация
  BUILT_SCHEME: "BUILT_SCHEME", // Исполнительная схема
  BUILT_BLUEPRINT: "BUILT_BLUEPRINT", // Исполнительный чертеж
  REGULATION_DOC: "REGULATION_DOC", // Нормативная документация
} as const;

export type DocTypeEnum = (typeof DocTypeTypes)[keyof typeof DocTypeTypes];

export const docTypeToEndpointMap: Record<DocTypeEnum, string> = {
  [DocTypeTypes.PROJECT_DOC]: "workingdraft",
  [DocTypeTypes.WORK_DOC]: "workingdraft",
  [DocTypeTypes.BUILT_SCHEME]: "executivescheme",
  [DocTypeTypes.BUILT_BLUEPRINT]: "executivedrawing",
  [DocTypeTypes.REGULATION_DOC]: "normative",
};

export const docTypeUsesPost: Record<DocTypeEnum, boolean> = {
  [DocTypeTypes.PROJECT_DOC]: false,
  [DocTypeTypes.WORK_DOC]: false,
  [DocTypeTypes.BUILT_SCHEME]: false,
  [DocTypeTypes.BUILT_BLUEPRINT]: true,
  [DocTypeTypes.REGULATION_DOC]: false,
};

export const docTypeToOldTab: Record<DocTypeEnum, string> = {
  [DocTypeTypes.PROJECT_DOC]: "working_draft",
  [DocTypeTypes.WORK_DOC]: "working_draft",
  [DocTypeTypes.BUILT_SCHEME]: "executive_scheme",
  [DocTypeTypes.BUILT_BLUEPRINT]: "executive_drawing",
  [DocTypeTypes.REGULATION_DOC]: "permits",
};
